import { TIER_THRESHOLDS, TierName, TierConfig } from '../challenge.model';

export function streakToTier(streak: number): TierName {
  let result: TierName = 'seed';
  for (const t of TIER_THRESHOLDS) {
    if (streak >= t.days) result = t.tier;
  }
  return result;
}

export function tierConfig(tier: TierName): TierConfig {
  const cfg = TIER_THRESHOLDS.find(t => t.tier === tier);
  if (!cfg) throw new Error(`Unknown tier: ${tier}`);
  return cfg;
}

export function tierMotifCount(tier: TierName): number {
  return tierConfig(tier).motifCount;
}

export function tierHasAccentDots(tier: TierName): boolean {
  return tierConfig(tier).accentDots;
}

export function tierHasHaloBoost(tier: TierName): boolean {
  return tierConfig(tier).haloBoost;
}

export function tierHasInnerEcho(tier: TierName): boolean {
  return tierConfig(tier).innerEcho;
}

export function tierHasRotation(tier: TierName): boolean {
  return tierConfig(tier).rotate;
}
